import type VirtualizedGroupHeader from '../type/VirtualizedGroupHeader';
import virtualizedMailGroupHeadersStore from '../store/store';
import { mutatorAction } from 'satcheljs';
import type { GroupHeaderId } from '../type/GroupHeaderId';
import type { TableView } from 'owa-mail-list-store';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import {
    isPinnedGroupHeader,
    setPinnedGroupHeaderCollapsedState,
} from '../utils/pinnedGroupHeaderCollapseState';

// Toggles collapsed status for header
const toggleVirtualizedGroupHeaderCollapseMutator: (
    headerName: GroupHeaderId,
    tableView: TableView
) => void = mutatorAction(
    'toggleVirtualizedGroupHeaderCollapse',
    function toggleVirtualizedGroupHeaderCollapse(
        headerName: GroupHeaderId,
        tableView: TableView
    ): void {
        const groupHeaderForToggle: VirtualizedGroupHeader | undefined =
            virtualizedMailGroupHeadersStore().virtualizedGroupHeaders.get(headerName);
        if (groupHeaderForToggle) {
            groupHeaderForToggle.isCollapsed = !groupHeaderForToggle.isCollapsed;
            if (isPinnedGroupHeader(groupHeaderForToggle.headerId)) {
                setPinnedGroupHeaderCollapsedState(
                    getMailboxInfo(tableView),
                    groupHeaderForToggle.isCollapsed
                );
            }
        }
    }
);
export default toggleVirtualizedGroupHeaderCollapseMutator;
